import { omit, stringifyParams } from '@/lib/helpers'
import { sliceApi } from '@/slices/api'

import type {
  GETGenericListResponseRequired,
  OffsetSearchParams,
} from '../api/types'
import type { Company } from '../api/types/hor'

export const companySliceApi = sliceApi
  .enhanceEndpoints({ addTagTypes: ['Company'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCompanies: builder.query<
        GETGenericListResponseRequired<Company>,
        OffsetSearchParams
      >({
        query: (params) =>
          `/admin/admin/companies${stringifyParams(omit(params, ['mergable']))}`,
        providesTags: ['Company'],
      }),
      getRmcCompanies: builder.query<
        GETGenericListResponseRequired<Company>,
        OffsetSearchParams & { rmcId?: string | number }
      >({
        query: ({ rmcId, ...params }) =>
          `/admin/rmc/${rmcId || 'rmc'}/companies${stringifyParams(
            omit(params, ['mergable'])
          )}`,
        providesTags: ['Company'],
      }),
      getPaginatedRmcCompanies: builder.query<
        GETGenericListResponseRequired<Company>,
        OffsetSearchParams & {
          rmcId?: string | number
          sort?: string
          order?: string
        }
      >({
        query: ({ rmcId, ...params }) =>
          `/admin/rmc/${rmcId || 'rmc'}/companies${stringifyParams(
            omit(params, ['mergable'])
          )}`,
        providesTags: ['Company'],
      }),
    }),
    overrideExisting: false,
  })

export const {
  useLazyGetCompaniesQuery,
  useGetRmcCompaniesQuery,
  useLazyGetRmcCompaniesQuery,
  useLazyGetPaginatedRmcCompaniesQuery,
} = companySliceApi
